class Scheme {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-scheme="scope"]',
            input: '[data-scheme="input"]',
            table: '[data-scheme="table"]',
            timeoff: '[data-scheme="timeoff"]',
            timeoffText: '[data-scheme="timeoff-text"]',
            timeoffIcon: '[data-scheme="timeoff-icon"]',
            wrapper: '[data-scheme="input-wrapper"]',
            times: '[data-scheme="times"]',
        }, config);

        this.$scope = $(this.config.scope);

        if (this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.addEventListeners();
        this.addAiEventListeners();
        this.refreshTable();
        this.checkInputs()
    }

    addEventListeners() {
        this.$scope.on('change', this.config.input, this.refreshTable.bind(this));
        this.$scope.on('change', this.config.timeoff, this.clearInputsIfNeeded.bind(this));
    }

    addAiEventListeners() {
        this.$scope.on('click', '#ai-modal-btn', () => { $('#ai-modal').modal('show'); });
        this.$scope.on('change', '#date1, #date2', this.toggleAiModalButton.bind(this));
        $('#ai-modal').on('click', '#ai-generate-btn', this.generateAiSchedule.bind(this));
        $('#ai-modal').on('click', '#ai-show-prompt-btn', this.showPromptPreview.bind(this));
        $('#ai-modal').on('click', '#ai-edit-hours-btn', this.toggleWorkHoursEdit.bind(this));
        this.toggleAiModalButton();
    }

    toggleAiModalButton() {
        let date1 = this.$scope.find('#date1').val();
        let date2 = this.$scope.find('#date2').val();
        this.$scope.find('#ai-modal-btn').prop('disabled', !date1 || !date2);
    }

    toggleWorkHoursEdit() {
        let $modal = $('#ai-modal');
        let $list = $modal.find('#ai-work-hours-list');
        let $edit = $modal.find('#ai-work-hours-edit');
        let $btn = $modal.find('#ai-edit-hours-btn');

        if ($edit.is(':visible')) {
            $modal.find('.ai-work-hours').each(function () {
                let day = $(this).data('day');
                let type = $(this).data('type');
                let val = $(this).val();
                let $display = $modal.find('[data-hours-display="' + day + '"]');
                let current = $display.text().split(' - ');
                if (type === 'open') current[0] = val;
                else current[1] = val;
                $display.text(current[0] + ' - ' + current[1]);
            });
            $edit.hide();
            $list.show();
            $btn.html('<i class="fas fa-pencil-alt"></i>');
        } else {
            $list.hide();
            $edit.show();
            $btn.html('<i class="fas fa-check"></i>');
        }
    }

    generateAiSchedule() {
        let date1 = this.$scope.find('#date1').val();
        let date2 = this.$scope.find('#date2').val();

        let $modal = $('#ai-modal');
        let extraPrompt = $modal.find('#extra_prompt').val();
        let exampleSchemeId = $modal.find('#example_scheme_id').val();
        let $btn = $modal.find('#ai-generate-btn');
        let $loading = $modal.find('#ai-loading');
        let $error = $modal.find('#ai-error');
        let $success = $modal.find('#ai-success');

        let workHours = {};
        $modal.find('.ai-work-hours').each(function () {
            let day = $(this).data('day');
            let type = $(this).data('type');
            if (!workHours[day]) workHours[day] = {};
            workHours[day][type] = $(this).val();
        });

        $btn.prop('disabled', true);
        $loading.show();
        $error.hide();
        $success.hide();
        $modal.find('#ai-explanation').hide();

        $.ajax({
            url: '/roosters/ai-generate',
            method: 'POST',
            data: {
                date1: date1,
                date2: date2,
                extra_prompt: extraPrompt,
                example_scheme_id: exampleSchemeId || null,
                work_hours: workHours,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: (response) => {
                if (response.success) {
                    this.populateSchedule(response.schedule);
                    this.refreshTable();
                    $success.show();
                    if (response.explanation) {
                        let $explanation = $modal.find('#ai-explanation');
                        $modal.find('#ai-explanation-text').text(response.explanation);
                        $explanation.show();
                        $explanation[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                } else {
                    this.showAiError(response.error || 'Er is een onbekende fout opgetreden.');
                }
            },
            error: (xhr) => {
                let msg = 'Er is een fout opgetreden. Probeer het opnieuw.';
                if (xhr.responseJSON && xhr.responseJSON.error) {
                    msg = xhr.responseJSON.error;
                }
                this.showAiError(msg);
            },
            complete: () => {
                $btn.prop('disabled', false);
                $loading.hide();
            }
        });
    }

    populateSchedule(schedule) {
        for (let userId in schedule) {
            let userData = schedule[userId];
            for (let day = 1; day <= 6; day++) {
                let dayKey = 'day' + day;
                let dayData = userData[dayKey];
                if (!dayData) continue;

                let prefix = 'user[' + userId + '][' + dayKey + ']';

                $('input[name="' + prefix + '[1]"]').val(dayData.start1 || '');
                $('input[name="' + prefix + '[2]"]').val(dayData.end1 || '');
                $('input[name="' + prefix + '[3]"]').val(dayData.start2 || '');
                $('input[name="' + prefix + '[4]"]').val(dayData.end2 || '');

                let $timeoffCheckbox = $('input[name="' + prefix + '[timeoff]"]');
                if (dayData.timeoff) {
                    if (!$timeoffCheckbox.is(':checked')) {
                        $timeoffCheckbox.prop('checked', true).trigger('change');
                    }
                } else {
                    if ($timeoffCheckbox.is(':checked')) {
                        $timeoffCheckbox.prop('checked', false).trigger('change');
                    }
                }
            }
        }
    }

    showPromptPreview() {
        let date1 = this.$scope.find('#date1').val();
        let date2 = this.$scope.find('#date2').val();
        let $modal = $('#ai-modal');
        let extraPrompt = $modal.find('#extra_prompt').val();
        let exampleSchemeId = $modal.find('#example_scheme_id').val();

        let workHours = {};
        $modal.find('.ai-work-hours').each(function () {
            let day = $(this).data('day');
            let type = $(this).data('type');
            if (!workHours[day]) workHours[day] = {};
            workHours[day][type] = $(this).val();
        });

        let $preview = $modal.find('#ai-prompt-preview');
        let $text = $modal.find('#ai-prompt-text');
        let $btn = $modal.find('#ai-show-prompt-btn');

        if ($preview.is(':visible')) {
            $preview.hide();
            $btn.html('<i class="fas fa-code mr-1"></i> Toon prompt');
            return;
        }

        $btn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin mr-1"></i> Laden...');

        $.ajax({
            url: '/roosters/ai-preview-prompt',
            method: 'POST',
            data: {
                date1: date1,
                date2: date2,
                extra_prompt: extraPrompt,
                example_scheme_id: exampleSchemeId || null,
                work_hours: workHours,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: (response) => {
                $text.text(response.prompt);
                $preview.show();
                $btn.html('<i class="fas fa-code mr-1"></i> Verberg prompt');
            },
            error: () => {
                this.showAiError('Kon de prompt niet ophalen.');
            },
            complete: () => {
                $btn.prop('disabled', false);
            }
        });
    }

    showAiError(message) {
        let $modal = $('#ai-modal');
        let $error = $modal.find('#ai-error');
        let $success = $modal.find('#ai-success');
        $success.hide();
        $error.text(message).show();
    }

    refreshTable() {
        let $form = this.$scope.find('form');
        $.ajax({
            url: '/roosters/ajax',
            method: 'POST',
            data: $form.serialize(),
            success: (response) => {
                this.$scope.find(this.config.table).html(response);
            }
        })
    }

    clearInputsIfNeeded(e) {
        let $input = $(e.currentTarget);
        let valid = $input.is(':checked');
        let $wrapper = $input.closest(this.config.wrapper);

        if(!valid) {
            let $text = $wrapper.find(this.config.timeoffText);
            let $icon = $wrapper.find(this.config.timeoffIcon);
            let $times = $wrapper.find(this.config.times);
            $icon.removeClass('fas').removeClass('fa-check').removeClass('text-success');
            $icon.addClass('fa').addClass('fa-times').addClass('text-danger');
            $text.css('display', 'none');
            $times.css('display', '');
            return;
        }

        $wrapper.find(this.config.input).each((index, input) => {
            $(input).val('').trigger('change');
        });

        this.checkInput($input);
    }

    checkInputs() {
        this.$scope.find(this.config.timeoff + ':checked').each((index, input) => {
            this.checkInput($(input));
        });
    }

    checkInput($input) {
        let $wrapper = $input.closest(this.config.wrapper);
        let $text = $wrapper.find(this.config.timeoffText);
        let $icon = $wrapper.find(this.config.timeoffIcon);
        let $times = $wrapper.find(this.config.times);

        $icon.addClass('fas').addClass('fa-check').addClass('text-success');
        $icon.removeClass('fa').removeClass('fa-times').removeClass('text-danger');
        $text.css('display', '');
        $times.css('display', 'none');
    }
}

export default new Scheme;
